import axiosConfig from "./axiosConfig";
import { GlobalStateRecord } from "./getGlobalState";

export interface UpdateGlobalStateRequest {
  type: string;
  name: string;
  value: string;
}

const putGlobalState = async (
  authToken: string,
  stateId: string,
  body: UpdateGlobalStateRequest
): Promise<{ globalState: GlobalStateRecord }> => {
  const { data } = await axiosConfig.put(`/global-state/${stateId}`, body, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default putGlobalState;
